export default __webpack_public_path__ + "openstata_logo.png";